export class ListReceiptMoneyViewModel {
    id : number;
    fromHubId:number;
    toHubId: number;
    paidByEmpId: number;
    totalShipment:number;
    totalCOD: number;
    totalPrice:number;
    grandTotal:number;
    attachmentId: number;
    shipments: any[];
    note: string;
    bankAccount: string;
    feeBank: number = 0;
}
// export class ShipmentToReceipt
// {
//     id : number;
//     cOD: number;
//     totalPrice:number;
// }